<template>
  <div class="review-course">
    <div class="left">
      <h1 class="title">学科</h1>
      <div class="courses">
        <div
          class="course"
          :class="{'active': currentCourse.courseName === course.courseName}"
          v-for="(course, index) in courses"
          :key="index"
          @click="selectCourse(course)">
            <span>{{course.courseName}}</span>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="title">
        <span class="vertical-line"></span>
        <span>课程</span>
        <el-input
          class="search-input"
          v-model="courseName"
          placeholder="搜索课程">
          <el-button
            class="btn btn-primary"
            @change="onSearchCourseName"
            @click="onSearchCourseName"
            slot="append"
            icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="content">
        <div class="subjects" v-show="searchBookList.length">
          <div class="books"
            v-for="(book, index) in searchBookList"
            :key="index">
            <div
              class="book"
              :class="{'active': currentBook.id === book.id}"
              @click="selectBook(book)">
              <div class="icon-wrapper">
                <div v-show="currentBookInfo.id === book.id" class="progress-wrapper">
                  <el-progress
                    color="#5256e6"
                    type="circle"
                    :percentage="currentBookInfo.progress"></el-progress>
                </div>
                <img class="icon" :src="book.cover" />
              </div>
              <div class="book-info">
                <div class="book-name">{{book.name}}</div>
                <div class="book-type">{{book.subjectName}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!searchBookList.length">
          <div class="subjects"
            v-for="(subject, index) in currentCourse.subject"
            :key="index">
            <div class="books"
              v-for="(book, index) in subject.bookList"
              :key="index">
              <div
                class="book"
                :class="{'active': currentBook.id === book.id}"
                @click="selectBook(book, subject)">
                <div class="icon-wrapper">
                  <div v-show="currentBookInfo.id === book.id" class="progress-wrapper">
                    <el-progress
                      color="#5256e6"
                      type="circle"
                      :percentage="currentBookInfo.progress"></el-progress>
                  </div>
                  <img class="icon" :src="book.cover" />
                </div>
                <div class="book-info">
                  <div class="book-name">{{book.name}}</div>
                  <div class="book-type">{{subject.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="title">
        <span class="vertical-line"></span>
        <span>课程目录</span>
      </div>
      <div class="content">
        <div
          class="unit"
          :class="{ 'active': currentUnit.id === unit.id }"
          :key="unit.id"
          v-for="(unit, index) in unitList"
          @click="selectUnit(unit, index)">
          <div class="control">
            <div class="name">{{unit.name}}</div>
            <div>
              <div class="describe">请选择复习的数量</div>
              <el-input-number
                v-model="modelUnitList[index].count"
                ref="input"
                :min="1"
                :max="maxNumber(unit.count)"
                :step="1"
                @change="onCountChange"
                step-strictly />
            </div>
          </div>
        </div>
      </div>
      <div
        class="start btn btn-orange-square"
        :class="{'disable': !currentUnit.id}"
        @click="start">
        <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/060d9178fa0157db28b0324d8c90f1b2.png" alt="">
        开始复习
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/graphql/learning';
import utils from '@/services/utils';
import {
  Input,
  Button,
  Progress,
  InputNumber,
} from 'element-ui';

export default {
  components: {
    ElInput: Input,
    ElButton: Button,
    ElProgress: Progress,
    ElInputNumber: InputNumber,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      courses: [],
      currentCourse: {},
      currentBook: {},
      currentBookInfo: {},
      courseName: '',
      searchBookList: [],
      currentUnit: {},
      unitList: [],
      currentCount: 0,
      modelUnitList: [],
    };
  },
  watch: {
    courseName() {
      this.onSearchCourseName();
    },
    currentBook() {
      const { id } = this.currentBook;
      this.getCourseInfo(id);
    },
    show() {
      if (this.show) {
        this.fetchCourseList();
      }
    },
  },
  computed: {
    currentSubjectName() {
      const { subjectName = '' } = this.currentBook;
      const subject = subjectName.split('-');
      return subject.length >= 2 ? subject[1] : '';
    },
  },
  methods: {
    fetchCourseList() {
      api
        .getCourseList({
          type: 'active',
        })
        .then(({ courses }) => {
          this.courses = courses;
          if (this.courses.length && !this.currentCourse.subject) {
            const [firstCourse] = this.courses;
            const { subject: [firstBookList] } = firstCourse;
            const { bookList } = firstBookList;
            const [firstBook] = bookList;

            this.currentCourse = firstCourse;
            this.currentBook = {
              ...firstBook,
              subjectName: firstBookList.name,
            };
          }
        });
    },
    onSearchCourseName() {
      const { subject = [] } = this.currentCourse;
      this.searchBookList = [];
      subject.forEach((item) => {
        item.bookList.forEach((book) => {
          const reg = new RegExp(this.courseName);
          if (reg.test(book.name)) {
            this.searchBookList.push({
              ...book,
              subjectName: item.name,
            });
          }
        });
      });
      if (!this.searchBookList.length) {
        utils.debounce(() => {
          utils.error('暂无相关课程，请检查关键字');
        }, 1000)();
      }
    },
    selectCourse(course) {
      this.courseName = '';
      this.searchBookList = [];
      this.currentCourse = course;
    },
    selectBook(book, subject) {
      this.currentUnit = {};
      if (this.currentBook.id === book.id) return;

      this.currentBook = book;
      if (subject) {
        this.currentBook.subjectName = subject.name;
      }
    },
    start() {
      const scene = 'quizzesDialog';
      let type;
      let count = 0;

      if (!this.currentUnit.id) return;
      if (this.currentCount) {
        count = this.currentCount;
        /* eslint-disable prefer-destructuring */
      } else if (this.currentUnit.count >= 50) {
        count = 50;
      } else {
        count = this.currentUnit.count;
      }

      if (this.currentBook.type === 'BDC') {
        type = 'bdc_review';
      } else {
        type = 'active_review';
      }
      this.$emit('change', {
        scene,
        params: {
          course: this.currentBook,
          moduleId: this.currentUnit.id,
          unit: {
            id: this.currentUnit.id,
            name: this.currentUnit.name,
          },
          count,
          type,
        },
      });
    },
    getCourseInfo(id) {
      api.getCourseReviewUnitList({
        courseId: id,
      }).then(({ courseReviewUnitList }) => {
        this.unitList = courseReviewUnitList;
        this.modelUnitList = utils.clone(courseReviewUnitList);
      });
    },
    onCarouselChange() {
      const videos = this.$refs.video;
      videos.forEach((video) => {
        video.pause();
      });
    },
    maxNumber(count) {
      if (count <= 50) {
        return count;
      }
      return 50;
    },
    selectUnit(unit, index) {
      this.currentCount = this.$refs.input[index].value;
      this.currentUnit = unit;
    },
    onCountChange(count) {
      this.currentCount = count;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .review-course {
    display: flex;
    position: absolute;
    left: calc(50% - 70vh);
    top: calc(50% - 40vh);
    height: 80vh;
    background: $primary;
    border-radius: 24px;
    .left {
      width: 15vh;
      height: 100%;
      color: #fff;
      .title {
        margin: 4vh 0;
        font-size: 2.3vh;
        text-align: center;
      }
      .courses {
        .course {
          height: 4.63vh;
          margin: 1.4vh 0;
          padding: .5vh 0;
          font-size: 2vh;
          line-height: 4.63vh;
          font-weight: 700;
          text-align: center;
          cursor: pointer;
          span {
            display: inline-block;
            transition: transform .15s;
            &:hover {
              transform: scale(1.05);
            }
          }
          &.active {
            color: $primary;
            background: #fff;
          }
        }
      }
    }
    .center {
      display: flex;
      flex-direction: column;
      width: 60vh;
      margin: 10px 0;
      height: calc(100% - 20px);
      background: #fff;
      border-radius: 18px;
      .title {
        position: relative;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin: 2.31vh 0 0.9vh;
        padding-left: 2.6vh;
        font-size: 2.5vh;
        font-weight: 700;
        .vertical-line {
          display: inline-block;
          width: 3px;
          height: 15px;
          margin-right: 1vh;
          background: $primary;
          border-radius: 18px;
        }
        /deep/ .search-input {
          position: absolute;
          right: 20px;
          width: 200px;
          text-align: center;
          .el-input-group__append {
            background: $primary;
            border-width: 1px 0;
            border-color: $primary;
            cursor: pointer;
            &:hover {
              filter: brightness(108%);
            }
            .el-button {
              padding: 1vh;
              .el-icon-search {
                color: #fff;
              }
            }
          }
          .is-active, .el-input__inner:focus {
            border-color: $primary;
          }
        }
      }
      .content {
        box-sizing: border-box;
        padding-left: 2.6vh;
        padding-right: 1vh;
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        border-radius: 18px;
        .subjects {
          box-sizing: border-box;
          padding-bottom: 1.39vh;
          .books {
            .book {
              box-sizing: border-box;
              display: flex;
              align-items: center;
              margin-top: 1.48vh;
              padding: 1vh;
              width: 100%;
              border-radius: 18px;
              cursor: pointer;
              &.active {
                background: #e8e9fc;
                .book-info {
                  .book-name {
                    color: $primary;
                    font-weight: 700;
                  }
                  .book-type {
                    width: 100%;
                    color: $primary;
                    font-weight: 700;
                  }
                }
              }
              &:hover {
                transform: scale(1.02);
              }
              .icon-wrapper {
                position: relative;
                width: 13vh;
                height: 17vh;
                border-radius: 10px;
                overflow: hidden;
                .icon {
                  width: 100%;
                  height: 100%;
                }
                .progress-wrapper {
                  position: absolute;
                  left: 0;
                  top: 0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  height: 100%;
                  background: rgba($color: #000000, $alpha: .5);
                  /deep/ .el-progress {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 8vh;
                    height: 8vh;
                    .el-progress-circle {
                      width: 100%!important;
                      height: 100%!important;
                    }
                    .el-progress__text {
                      color: #fff;
                    }
                  }
                }
              }
              .book-info {
                margin-left: 1.85vh;
                width: 60%;
                color: #333;
                .book-name {
                  margin-bottom: 1.39vh;
                  width: 100%;
                  font-size: 2.85vh;
                  font-weight: 700;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
                .book-type {
                  width: 100%;
                  font-size: 2vh;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
            }
          }
        }
      }
    }
    .right {
      position: relative;
      box-sizing: border-box;
      margin: 10px 10px 10px 2vh;
      padding: 0 2.67vh;
      width: 65vh;
      height: calc(100% - 20px);
      background: #fff;
      border-radius: 18px;
      .title {
        position: relative;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin: 2.31vh 0 2vh;
        font-size: 2.5vh;
        font-weight: 700;
        .vertical-line {
          display: inline-block;
          width: 3px;
          height: 15px;
          margin-right: 1vh;
          background: $primary;
          border-radius: 18px;
        }
      }
      .content {
        height: 75%;
        overflow: auto;
        .unit {
          margin: 0 5px 10px;
          padding: 2vh;
          border: 1px solid $primary;
          border-radius: 18px;
          cursor: pointer;
          &.active {
            background: #e8e9fc;
            border: 1px solid #e8e9fc;
          }
          .name {
            width: calc(100% - 200px);
            font-size: 2.2vh;
            line-height: 1.8;
            word-break: break-all;
          }
          .control {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .describe {
            margin-bottom: 5px;
            display: flex;
            justify-content: center;
            color: #1A4654;
          }
          /deep/ .el-input-number {
            .el-input-number__decrease, .el-input-number__increase {
              background: $primary;
              .el-icon-plus {
                color: #fff;
              }
              .el-icon-minus {
                color: #fff;
              }
            }
            .el-input {
              .el-input__inner:hover {
                border: 1px solid $primary;
              }
              .el-input__inner:active {
                border: 1px solid $primary;
              }
              .el-input__inner:focus {
                border: 1px solid $primary;
              }
            }
          }
        }
      }
      .start {
        position: absolute;
        left: 50%;
        bottom: 5vh;
        font-size: 2vh;
        transform: translateX(-50%);
        cursor: pointer;
        &.disable {
          filter: grayscale(100%);
        }
        &:hover {
          opacity: .8;
        }
        img {
          margin-left: -2vh;
          width: 4vh;
        }
      }
    }
  }
</style>
